import React from 'react';
import Divider from './Divider';

const SettingsDivider = () => {
  return (
    <div className="my-6">
      <Divider />
    </div>
  );
};

export default SettingsDivider;
